import { render, staticRenderFns } from "./refundOrderdetail.vue?vue&type=template&id=fe632ece&scoped=true&"
import script from "./refundOrderdetail.vue?vue&type=script&lang=js&"
export * from "./refundOrderdetail.vue?vue&type=script&lang=js&"
import style0 from "./refundOrderdetail.vue?vue&type=style&index=0&id=fe632ece&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe632ece",
  null
  
)

export default component.exports